export const notion = {
  invitationAndEntryPointInformation:
    "https://half-pressure-b6c.notion.site/1800-1a6941dfbe4080448f10fba22ab5cba4?pvs=4",
  howToPlay: "https://half-pressure-b6c.notion.site/220941dfbe40800da923f1f28e0c499b?source=copy_link",
  gameDescription: "https://half-pressure-b6c.notion.site/220941dfbe408045988af40d1dc237c2?source=copy_link",
  help: "https://half-pressure-b6c.notion.site/FAQ-1e4941dfbe4080e6b886de7ee194eee4?source=copy_link",
  reportGuidelines: "https://half-pressure-b6c.notion.site/24d941dfbe4080c09aeade1bcf7c8403",
};
